<template>
<a-spin :spinning="spinning" tip="Loading...">
    <div class="card mb-3">
        <div class="row no-gutters">
            <div class="col-md-12" style="border-right: 1px solid #e0e0e0">
                <div class="card-body">
                    <div class="row">
                        <div class="col-md-7">
                            <div class="row">
                                <div class="col-md-7">
                                    <base-input alternative="" label="Select Site">
                                        <a-select mode="multiple" v-model="inputSite" showSearch placeholder="All Sites" optionFilterProp="children" style="width: 100%" :filterOption="filterOption">
                                            <a-select-option v-for="option in siteOptions" :key="option.id" :value="option.id">{{option.name}}</a-select-option>
                                        </a-select>
                                    </base-input>
                                </div>
                            </div>
        
                            <div class="row">
                                <div class="col-md-7">
                                    <base-input alternative="" label="Select Product Status">
                                        <a-select v-model="inputProductStatus" showSearch placeholder="All Product Status" optionFilterProp="children" style="width: 100%" :filterOption="filterOption">
                                            <a-select-option v-for="option in productStatusOptions" :key="option.key" :value="option.key">{{option.value}}</a-select-option>
                                        </a-select>
                                    </base-input>
                                </div>
                            </div>
                            <base-checkbox class="mb-3" v-model="isSeparateSite">
                                Separate Per Site
                            </base-checkbox>
                            <base-checkbox class="mb-3" v-model="withSitePriceOnly">
                                With Site Price Only
                            </base-checkbox>
                        </div>
                        <div class="col-md-4 align-self-center">
                            <div v-if="reportDescription != ''" class="card">
                                <div class="card-body">
                                    <div class="card-text">
                                        {{ reportDescription }}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>


                    <div class="row">
                        <div class="col-md-12">
                            <br>
                            <button class="btn btn-sm btn-default float-right" style="border-radius: 24px; border:0px; width: 20%;" @click.prevent="generateReport">Generate Report in PDF</button> &nbsp; &nbsp;
                            <button v-if="JsonData.length < 1" class="btn btn-sm btn-default float-right" style="border-radius: 24px; border:0px; width: 20%;" @click.prevent="generateFile">Generate Report</button> &nbsp; &nbsp;
                            <vue-json-to-csv v-if="JsonData.length > 0"  :show-labels="false" :json-data="JsonData" :csv-title="currentProfile.replace(/_/g, '-')+'-'+currDate.replace(/ /g, '_')">
                                <button id='clickCsvExport' @click.prevent="clearJsonData" class="btn btn-sm btn-success float-right" style="border-radius: 24px; border:0px; width: 20%;"> Download CSV </button> &nbsp; &nbsp;
                            </vue-json-to-csv>
                            <button v-if="JsonData.length > 0" class="btn btn-sm btn-success float-right" style="border-radius: 24px; border:0px; width: 20%%;" @click.prevent="generateExcel"> Download Excel</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</a-spin>
</template>

<script>
    import HTTPRequest from '../../controllers/httpRequest.js'
    import secureStorage from '../../controllers/secureStorage';
    import reportUtils from '../../components/reportUtils'
    import moment from 'moment';
    import jsPDF from 'jspdf';
    import 'jspdf-autotable';
    import VueJsonToCsv from 'vue-json-to-csv';
    import * as ExcelJS from "exceljs";
    import { saveAs } from "file-saver";
    import { getReportDescription } from '../../utilities';


    import {
        mapState
    } from 'vuex'

    export default {
        data() {
            return {
                spinning: false,
                accessCostPriceRights: [],
                currDate: moment().format("L_LT").split(":").join(";"),
                inputSite: [],
                site_type: "ho",
                siteOptions: [],
                terminalOptions: [],
                cashierOptions: [],
                birSalesReports: [],
                JsonData: [],
                inputProductStatus: "A",
                isSeparateSite: true,
                withSitePriceOnly: false,
                productStatusOptions: [
                    {key: 'A', value: 'Active'},
                    {key: 'I', value: 'Inactive'},
                    {key: 'D', value: 'Deleted'}
                ],
                productTypeOptions: [
                { key: '', value: 'Regular'},
                { key: 'R', value: 'Regular'},
                { key: 'P', value: 'Package'},
                { key: 'M', value: 'Matrix'},
                { key: 'I', value: 'Matrix Item'},
                { key: 'N', value: 'Non-Inventory'},
                { key: 'S', value: 'Serial Item'},
                { key: 'K', value: 'Kit'},
                { key: 'V', value: 'Virtual Kit'}
                ],
                reportDescription: ''
            }
        },
        mounted: async function () {
            var component_x = this;

            this.accessCostPriceRights = this.$attrs.access_costprice_rights || []

            var userId = secureStorage.getItem("userId")
            var sites = await HTTPRequest.getRequest(component_x.endPoint + "sites/get_valid_sites?user_id=" + userId, null);
            component_x.siteOptions = sites;
            component_x.sort(component_x.siteOptions);

            let siteId = secureStorage.getItem("defaultSiteId")
            this.inputSite = [siteId]

            let site = await HTTPRequest.getRequest(this.endPoint + "/sites/" + siteId, null)
            if(site != undefined){
                this.site_type = site.site_type
            }
            this.reportDescription = await getReportDescription(this.currentProfile)
            let terminals = await HTTPRequest.getRequest(component_x.endPoint + "terminals/get_valid_terminals?site_id=" + siteId, null);
            component_x.terminalOptions = terminals;
            component_x.terminalOptions.push({id: 0, name: ' All Terminals'})
            component_x.sort(component_x.terminalOptions);

            let users = await HTTPRequest.getRequest(component_x.endPoint + 'users/get_valid_cashiers', null);
            component_x.cashierOptions = users;
            component_x.cashierOptions.push({id: 0, first_name: ' All Users', last_name: ''})
            component_x.cashierOptions.sort(function (a, b) {
                let aname = a.first_name + ' ' + a.last_name
                let bname = b.first_name + ' ' + b.last_name
                return aname.localeCompare(bname);
            });
            
        },
        computed: {
            ...mapState(['currentProfile', 'currentApiURL', 'endPoint', 'parameters']),
        },
        components:{
            VueJsonToCsv
        },
        methods: {
            moment,
            filterOption(input, option) {
                return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
            },
            sort(data){
                data.sort(function (a, b) {
                    return a.name.localeCompare(b.name);
                });
            },
            convertToCurrency(num){
                return num.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
            },
            addMaskValidation(value, rights){
                if((!this.accessCostPriceRights.includes('Z') && rights == 'Z') || (!this.accessCostPriceRights.includes('Y') && rights == 'Y')){
                    return '***';
                }else{
                    return value
                }
            },
            openNotificationWithIcon(type, msg) {
                this.$notification[type]({
                    message: 'Export Error',
                    description: msg 
                });
            },
            isJsonString(str) {
                try {
                    var json = JSON.parse(str);
                    return (typeof json === 'object');
                } catch (e) {
                    return false;
                }
            },
            generateReport: async function () {
                this.spinning= true;

                var get_request = await HTTPRequest.getRequest(this.endPoint + 'product_pricing?site_id=' + this.inputSite + '&inputProductStatus=' + this.inputProductStatus + '&withSitePriceOnly=' + this.withSitePriceOnly + '&isSeparateSite=' + this.isSeparateSite , null);

                let reportLogo = document.getElementById('reportLogo');

                var siteSpecific = get_request;
                if(siteSpecific.length > 0){
                    let doc = new jsPDF({ orientation: 'landscape', unit: 'mm', format: 'legal' });

                    for(var x=0; x < siteSpecific.length; x++){
                        doc.addImage(reportLogo, "PNG", 15, 0, 15, 15);

                        doc.setFontSize(14);
                        doc.setFontType("bold");

                        let design_y = 20
                        
                        doc.text(15,design_y,`Product Pricing Report`)
                        doc.setFontType("normal");
                        doc.setFontSize(10);

                        design_y = design_y + 5;

                        if(x > 0 ){
                            //add new page
                            doc.addPage();
                        }
                        let site_text = (this.inputSite.length == 0) ? 'All Sites': '';
                        let sites = this.inputSite
                        if(sites.length > 0) {
                            for (var s = 0; s < sites.length; s++) {
                                if(s == 0){
                                    site_text += this.siteOptions.find(x => x.id === sites[s]).name
                                } else {
                                    site_text += ', ' + this.siteOptions.find(x => x.id === sites[s]).name
                                }
                            }
                        }

                        doc.text(15,design_y,"Sites: " + site_text)
                        
                        if(this.withSitePriceOnly) {
                            design_y = design_y + 5;
                            doc.text(15,design_y,"With Site Price Only")
                        }
                            
                        this.birSalesReports = siteSpecific[x].report_details

                        let grouper = ''

                        let detailColStyles = {
                            0: {cellWidth: 40},
                            1: {cellWidth: 40},
                            2: {cellWidth: 100},
                            3: {cellWidth: 25},
                            4: {cellWidth: 25},
                            5: {cellWidth: 25},
                            6: {cellWidth: 25},
                            7: {cellWidth: 50},
                        } 
                        
                        let header = [
                            {content: 'Barcode', styles: {halign: 'center'}},
                            {content: 'Stock No.', styles: {halign: 'center'}},
                            {content: 'Description', styles: {halign: 'center'}},
                            {content: 'Master\nRetail Price', styles: {halign: 'center'}},
                            {content: 'Site\nRetail Price', styles: {halign: 'center'}},
                            {content: 'Product\nType', styles: {halign: 'center'}},
                            {content: 'Status', styles: {halign: 'center'}},
                            {content: 'Site Name', styles: {halign: 'center'}}
                        ]

                        if(this.birSalesReports.length > 0){
                            let reportData = []
                            let grouper = 'start'
                            
                            for(let i=0; i < this.birSalesReports.length; i++){
                                let reportLine = this.birSalesReports[i]
                                
                                if(this.isSeparateSite) {
                                    let grouper_name = reportLine.site_name
                                    if(grouper == 'start'){
                                        let detail_header = [{content: `Site: ${grouper_name}`, colSpan: 2, styles: {halign: 'left', fontStyle: 'bold'}}];
                                        reportData.push(Object.assign({}, detail_header))
                                    } else {
                                        if(grouper != reportLine.site_name){
                                            let detail_header = [{content: `Site: ${grouper_name}`, colSpan: 2, styles: {halign: 'left', fontStyle: 'bold'}}];
                                            reportData.push(Object.assign({}, detail_header))
                                        }
                                    }
                                    grouper = reportLine.site_name
                                }   
                            
                                //body
                                let detail = [
                                    {content: reportLine.barcode, styles: {halign: 'left'}},
                                    {content: reportLine.stock_no, styles: {halign: 'left'}},
                                    {content: reportLine.name, styles: {halign: 'left'}},
                                    {content: this.addMaskValidation((reportLine.master_retail_price == -1) ? '': this.convertToCurrency(Number(reportLine.master_retail_price)), 'Y'), styles: {halign: 'right'}},
                                    {content: this.addMaskValidation((reportLine.site_retail_price == -1) ? '': this.convertToCurrency(Number(reportLine.site_retail_price)), 'Y'), styles: {halign: 'right'}},
                                    {content: this.productTypeOptions.find(x => x.key === reportLine.product_type).value, styles: {halign: 'center'}},
                                    {content: this.productStatusOptions.find(x => x.key === reportLine.status).value, styles: {halign: 'center'}},
                                    {content: reportLine.site_name, styles: {halign: 'left'}}
                                ]
                            
                                reportData.push(detail)
                                
                               
                                if(i == this.birSalesReports.length-1){
                                    
                                    //create table
                                    design_y = design_y + 5
                                    doc.autoTable({
                                        startY: design_y, 
                                        head: [header],
                                        body: reportData, 
                                        theme: 'plain',
                                        tableWidth: 'wrap',
                                        headStyles: {
                                            lineWidth: 0.15
                                        },
                                        styles: {
                                            cellPadding: 1.0, fontSize: 9,
                                            halign: 'right'
                                        },
                                        columnStyles: detailColStyles,
                                        didParseCell: function(data) {
                                            if (data.row.section == 'body' && data.row.raw[0] == 'rowLine'){
                                                data.cell.styles.fillColor = [0, 0, 0]
                                                data.cell.styles.fontSize = 1
                                                data.cell.styles.cellPadding = 0
                                            } else if (data.row.section == 'body' && data.row.raw[6] == 'Total :'){
                                                data.cell.styles.fontStyle = 'bold'
                                            }
                                        }
                                    });
                                }
                            }
                        }
                    }

                    let printed_by = secureStorage.getItem("email")
                    if(printed_by == null){
                        printed_by = ''
                    }

                    let pageCount = doc.internal.getNumberOfPages();
                    
                    for(let i = 0; i < pageCount; i++) { 
                        doc.setPage(i);
                        reportUtils.pdfTools.addFooter(doc, printed_by, "Product Expiration Report", 340, 200, i, pageCount, "right")
                    }
                    window.open(URL.createObjectURL(doc.output("blob")))
                } else {
                    this.openNotificationWithIcon('error', 'No Data to Export.');
                }
                this.spinning= false;
            },
            async generateExcel(){
                const workbook = new ExcelJS.Workbook();
                workbook.created = new Date();
                workbook.modified = new Date();
                const sheet = workbook.addWorksheet("Product Pricing Report", {
                    pageSetup:{paperSize: 9}
                });

                const data_starts_at_row = 8

                let reportLogo = document.getElementById('reportLogo');
            
                const base64Image = reportUtils.csvxlsxTools.getBase64Image(reportLogo)

                const imageId2 = workbook.addImage({
                    base64: base64Image,
                    extension: 'png',
                });

                sheet.addImage(imageId2, {
                    tl: { col: 0, row: 0 },
                    ext: { width: 61, height: 61 }
                });
                
                sheet.getRow(4).values = ["Product Pricing Report"]


                let site_text = (this.inputSite.length == 0) ? 'All Sites': '';
                    let sites = this.inputSite
                    if(sites.length > 0) {
                        for (var s = 0; s < sites.length; s++) {
                            if(s == 0){
                                site_text += this.siteOptions.find(x => x.id === sites[s]).name
                            } else {
                                site_text += ', ' + this.siteOptions.find(x => x.id === sites[s]).name
                            }
                        }
                    }
                sheet.getRow(5).values = ['Sites: ' + site_text]
                if(this.withSitePriceOnly) 
                    sheet.getRow(6).values = ['With Site Price Only']
                        
                //custom header
                sheet.getRow(data_starts_at_row).values = ['Barcode', 'Stock No', 'Description', 'Master Retail Price', 'Site Retail Price', 'Product Type', 'Status', 'Site Name'];

                sheet.columns = [
                    { key: "barcode" , width: 20 },
                    { key: "stock_no", width: 15 },
                    { key: "name" , width: 20 },
                    { key: "master_retail_price", width: 15 },
                    { key: "site_retail_price", width: 30 },
                    { key: "product_type", width: 15 },
                    { key: "status", width: 15 },
                    { key: "site_name", width: 15 }
                ];

                var report_details = this.JsonData
                var rowDatas = []
                var horizontal_range = 0
                for(let i = 4; i < report_details.length; i++){
                    const report_detail = report_details[i]
                        if(report_detail){
                            const rowData = {barcode: report_detail["Barcode"], stock_no: report_detail["Stock No"], name: report_detail["Description"], 
                            master_retail_price: report_detail["Master Retail Price"], site_retail_price: report_detail["Site Retail Price"], product_type: report_detail["Product Type"], status: report_detail["Status"] ,site_name: report_detail["Site Name"]}
                            rowDatas.push(rowData)
                        }
                    }

                sheet.addRows(rowDatas);

                //styles
                sheet.getRow(4).font = { bold: true, size: 12 };
                sheet.getRow(4).height = 20;
                // sheet.getRow(7).font = { bold: true };
                sheet.getRow(data_starts_at_row).font = { bold: true };

        
                sheet.eachRow(function (Row, rowNum) {
                    if(rowNum >= data_starts_at_row){
                        Row.eachCell(function (Cell, cellNum) {
                            if (rowNum == data_starts_at_row) {
                                Cell.alignment = {
                                    horizontal: 'center'
                                }
                            }
                            else{
                                Cell.alignment = {
                                    vertical: 'middle',
                                    horizontal: 'left'
                                }
                            }
                        })
                    }
                })
                
                workbook.xlsx.writeBuffer().then(function(buffer) {
                    const blob = new Blob([buffer], { type: "application/xlsx" });
                    saveAs(blob, `ProductPricingReport.xlsx`);
                });
                this.JsonData = []
            },
            generateFile: async function() {
                var get_request = await HTTPRequest.getRequest(this.endPoint + 'product_pricing?site_id=' + this.inputSite + '&inputProductStatus=' + this.inputProductStatus + '&withSitePriceOnly=' + this.withSitePriceOnly + '&isSeparateSite=' + this.isSeparateSite , null);

                var siteSpecific = get_request;
                if(siteSpecific.length > 0){
                    let headers = [];
                    let site_specific = [];
                    let reportData = []
                    reportData.push(Object.assign({}, ['Product Pricing Report']))

                    let site_text = (this.inputSite.length == 0) ? 'All Sites': '';
                    let sites = this.inputSite
                    if(sites.length > 0) {
                        for (var s = 0; s < sites.length; s++) {
                            if(s == 0){
                                site_text += this.siteOptions.find(x => x.id === sites[s]).name
                            } else {
                                site_text += ', ' + this.siteOptions.find(x => x.id === sites[s]).name
                            }
                        }
                    }

                    reportData.push(Object.assign({}, ['Sites: ' + site_text]))

                    if(this.withSitePriceOnly) 
                        reportData.push(Object.assign({}, ['With Site Price Only']))
                            
                        headers = ['Barcode', 'Stock No', 'Description', 'Master Retail Price', 'Site Retail Price', 'Product Type', 'Status', 'Site Name']
                        reportData.push(Object.assign({}, headers))
                        
                    for(var x=0; x < siteSpecific.length; x++){
                        this.birSalesReports = siteSpecific[x].report_details

                        if(this.birSalesReports.length > 0){
                            for(let i=0; i < this.birSalesReports.length; i++){
                                let reportLine = this.birSalesReports[i]
                                
                                //body
                                let detail = [
                                    reportLine.barcode,
                                    reportLine.stock_no,
                                    reportLine.name,
                                    this.addMaskValidation(this.convertToCurrency(Number(reportLine.master_retail_price)), 'Y'),
                                    this.addMaskValidation((reportLine.site_retail_price == -1) ? '' : this.convertToCurrency(Number(reportLine.site_retail_price)), 'Y'),
                                    this.productTypeOptions.find(x => x.key === reportLine.product_type).value,
                                    this.productStatusOptions.find(x => x.key === reportLine.status).value,
                                    reportLine.site_name
                                    ]
                                
                                reportData.push(detail)
                            }
                        }
                    }
                        let keys = headers;
                        let values = reportData;
                        var values_length = values.length;

                        let newJsonData=[];

                        // change headers and report data as key and value object
                        for(var i=0;i < values_length; i++){
                        	var result =  Object.assign.apply({}, keys.map( (val, index) => ( {
                              		[val]: values[i][index]
                            	  }
                              )
                            )
                          );
                          newJsonData.push(result)
                        }

                        // change undefined on arr
                        newJsonData.forEach(function(obj) {
                          for(var i in obj) {
                            if(obj[i] === undefined || obj[i] === null ) {
                              obj[i] = '';
                            }
                          }
                        });
                        site_specific.push(newJsonData)
                    
                    this.JsonData = site_specific.flat(Infinity);
                } else {
                    this.openNotificationWithIcon('error', 'No Data to Export.');
                }
                this.spinning= false;
            },
            clearJsonData(){
              this.JsonData = [];
            },
        }
    };
</script>

<style></style>